module.exports = __webpack_public_path__ + "img/stability1.061f1efd.png";